<div class="rangos-horarios-container">
  <div class="rangos-scroll-container">
    @for (rangoGroup of rangosArray.controls; track $index) {
      <mat-card class="rango-card" [formGroup]="rangoGroup">
        <div class="rango-header">
          <span class="rango-numero">Rango {{ $index + 1 }}</span>
          @if (rangosArray.controls.length > 1) {
            <button
              irxBotonIcono
              tono="peligro"
              type="button"
              (click)="eliminarRango($index)"
              [disabled]="disabled"
              tooltip="Eliminar rango"
            >
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>

        <div class="rango-content">
          <!-- Días de la semana -->
          <ng-select
            class="full-width"
            formControlName="dias"
            placeholder="Días"
            [items]="diasSemana"
            [multiple]="true"
            [closeOnSelect]="false"
            (blur)="onBlur()"
            appendTo="body"
            notFoundText="Sin resultados"
          ></ng-select>

          <!-- Horarios -->
          <div class="horarios-group">
            <app-time-picker
              class="horario-field"
              formControlName="horarioDesde"
              label="Desde"
              placeholder="HH:mm"
              (focusout)="onBlur()"
            ></app-time-picker>

            <app-time-picker
              class="horario-field"
              formControlName="horarioHasta"
              label="Hasta"
              placeholder="HH:mm"
              (focusout)="onBlur()"
            ></app-time-picker>
          </div>
        </div>
      </mat-card>
    }
  </div>

  <!-- Botón agregar rango -->
  <button
    irxBoton="secundario"
    type="button"
    (click)="agregarRango()"
    [disabled]="disabled"
    bloque
    tamano="campo"
  >
    <mat-icon>add</mat-icon>
    Agregar rango horario
  </button>
</div>
